import { useEffect, useState } from 'react';
import { designApi } from '../lib/api';

const BACKEND_URL = (typeof window !== "undefined" && window.location ? window.location.origin : process.env.REACT_APP_BACKEND_URL || "");
const HEADER_IMG_URL = `${BACKEND_URL}/api/settings/logos/public_header_bg`;

/**
 * Liefert die Konfiguration für den öffentlichen Header (Hintergrundbild +
 * Overlay) und merged Inline-Style-Objekte für Section + Overlay-Layer.
 *
 * Konsumenten:
 *   const { sectionStyle, overlayStyle, hasImage } = usePublicHeaderConfig();
 */
export function usePublicHeaderConfig() {
    const [cfg, setCfg] = useState(null);

    useEffect(() => {
        let active = true;
        designApi.get()
            .then(r => { if (active) setCfg(r.data?.colors || {}); })
            .catch(() => { if (active) setCfg({}); });
        return () => { active = false; };
    }, []);

    if (!cfg) {
        return {
            sectionStyle: undefined, overlayStyle: null, hasImage: false,
            extendTopbar: false, title: null, subtitle: null,
        };
    }

    const enabled = !!cfg.public_header_image_enabled;
    const opacity = Math.max(0, Math.min(100, parseInt(cfg.public_header_overlay_opacity ?? 60, 10))) / 100;
    const color = cfg.public_header_overlay_color || '#1F2937';
    const parallax = !!cfg.public_header_parallax;
    const extendTopbar = !!cfg.public_header_extend_topbar;
    const title = cfg.public_header_title || 'Fort- & Weiterbildungen';
    const subtitle = cfg.public_header_subtitle || 'Entdecken Sie unsere Seminare der BGPR-Akademie sowie Angebote externer Partner für Herzgruppenleiter.';

    if (!enabled) {
        return { sectionStyle: undefined, overlayStyle: null, hasImage: false, extendTopbar: false, title, subtitle };
    }

    const sectionStyle = {
        backgroundImage: `url(${HEADER_IMG_URL})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: parallax ? 'fixed' : 'scroll',
    };
    const overlayStyle = { backgroundColor: color, opacity };
    return { sectionStyle, overlayStyle, hasImage: true, extendTopbar, title, subtitle };
}
